/*
 * @Author: Chao Yang
 * @Date: 2020-03-09 11:11:21
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-03-15 02:08:14
 */
import { Injectable } from '@angular/core';
import { parse } from 'date-fns';
import { Observable, empty, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as Account from 'src/app/domain/model/account/index';
import { ActivityProxy } from 'src/app/domain/proxy/index';
import { SessionService } from '../session';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';

@Injectable()
export class ActivityService {
  constructor(
    private _activityProxy: ActivityProxy,
    private sessionService: SessionService
  ) {}

  getAccountDetailActivityCount(
    programId: number,
    date: number,
    endDate: Date,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<number> {
    return this._activityProxy.getAccountDetailActivityCount(
      programId,
      date,
      endDate,
      accounts
    );
  }

  getAccountDetailActivity(
    programId: number,
    date: number,
    pageSize: number,
    pageNumber: number,
    endDate: Date,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Account.IActivity[]> {
    return this._activityProxy
      .getAccountDetailActivity(
        programId,
        date,
        pageSize,
        pageNumber,
        endDate,
        accounts
      )
      .pipe(
        map((activies) => {
          activies.forEach((activity) => {
            if (
              activity.userDocumentResponse !== undefined &&
              activity.userDocumentResponse !== null
            ) {
              activity.userDocumentResponse.due = parse(
                activity.userDocumentResponse.documentDueDate,
                'yyyy-MM-dd',
                new Date()
              );
            }
          });
          return activies;
        })
      );
  }

  getAccountActivity(
    pageNumber: number,
    pageSize: number,
    lastCheckDate: Date,
    endDate: Date,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Account.IActivity[]> {
    return this._activityProxy.getAccountActivity(
      pageNumber,
      pageSize,
      lastCheckDate,
      endDate,
      accounts
    );
  }

  getActivityCount(
    lastCheckDate: Date,
    endDate: Date,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<number> {
    return this._activityProxy.getActivityCount(
      lastCheckDate,
      endDate,
      accounts
    );
  }

  getLastCheckDate(): Observable<Date> {
    return this._activityProxy
      .getLastCheckDate()
      .pipe(map((item) => new Date(item)));
  }

  putLastCheckDate(date: Date) {
    if (this.sessionService.isShadow()) {
      return this._activityProxy.getShadowUserDefaultObservable();
    }
    return this._activityProxy.putLastCheckDate(date);
  }

  createUserDocumentResponse(yesOrNo: boolean, comment: string, id: number) {
    if (this.sessionService.isShadow()) {
      return this._activityProxy.getShadowUserDefaultObservable();
    }
    return this._activityProxy.createUserDocumentResponse(yesOrNo, comment, id);
  }
}
